import { render, staticRenderFns } from "./automaticDistributionRules.vue?vue&type=template&id=0f78fc70&scoped=true"
import script from "./automaticDistributionRules.vue?vue&type=script&lang=js"
export * from "./automaticDistributionRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78fc70",
  null
  
)

export default component.exports